import { render, staticRenderFns } from "./soidown-item.vue?vue&type=template&id=891374c2"
import script from "./soidown-item.vue?vue&type=script&lang=js"
export * from "./soidown-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('891374c2')) {
      api.createRecord('891374c2', component.options)
    } else {
      api.reload('891374c2', component.options)
    }
    module.hot.accept("./soidown-item.vue?vue&type=template&id=891374c2", function () {
      api.rerender('891374c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/soidown-item.vue"
export default component.exports